import React from 'react';

import { getTabIndex } from '../../utils';
import SideBarNav from '../../components/molecule/SideBarNav';

import Account from './Account';
import Password from './Password';
import Payment from './Payment';

const baseRoute = '/settings';
const Settings = ({
  match,
  ...other
}) => {

  const navTabs = [
    {
      label: 'Account',
      header: 'Account',
      path:`${baseRoute}/account`,
      component: <Account match={match} {...other}/>,
      props: { to: `${baseRoute}/account` }
    },
    {
      label: 'Password',
      header: 'Password',
      path:`${baseRoute}/password`,
      component: <Password match={match} {...other}/>,
      props: { to: `${baseRoute}/password` }
    },
    {
      label: 'Payment',
      header: 'Stripe Payment',
      path:`${baseRoute}/stripe`,
      component: <Payment match={match} {...other}/>,
      props: { to: `${baseRoute}/stripe` }      
    }
  ]

  return (
    <SideBarNav
      value={getTabIndex(match.url,navTabs)}
      navComponents={navTabs}
      {...other}
    />
  );
}

Settings.propTypes = {

};

export default Settings;
